import {
  employeeCheck,
  employeeSaveOrEdit,
  getEmployeeList,
  getPositionList,
  resetPassword,
} from '@/services/homeService'
import { dfs } from '@/utils/common'
import { PlusOutlined } from '@ant-design/icons'
import { useSetState } from 'ahooks'
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Switch,
  Table,
  Tree,
  message,
} from 'antd'
import dayjs from 'dayjs'
import { cloneDeep, get, isNil } from 'lodash-es'
import React, { useEffect, useRef, useState } from 'react'
import { SActionBtn, SDrawer, SLowcodeList, STableActions } from 'shj-components'
import config from './config'

interface IAddOrEditProps {
  reload?: (values: object) => void
  onClose?: (values: object) => void
  record?: any
  open?: boolean
  type?: string
  title?: string
  orgTree?: array
  idcardOptions?: array
  positionTypeOptions?: array
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 17 },
  },
}

const formSpan = 8

const EditDrawer: React.FC<IAddOrEditProps> = (props: IAddOrEditProps) => {
  const {
    record,
    reload,
    onClose,
    open,
    type,
    title,
    orgTree,
    idcardOptions,
    positionTypeOptions,
  } = props
  const tableRef = useRef<any>()
  const editRef = useRef<any>({})
  const id = record?.id
  const [form] = Form.useForm()
  const { setFieldsValue } = form
  const [submitLoading, setSubmitLoading] = useState<boolean>(false)
  // const [data, setData] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState(false)

  const [state, setState] = useSetState<any>({
    // submitLoading: false,
    fileList: [],
    orgTreeData: [],
    positionList: [],
    seletedPosition: [],
    primaryDeptPosId: '',
  })

  useEffect(() => {
    const orgTreeData = cloneDeep(orgTree)
    dfs(orgTreeData, (item: any) => {
      item.key = item.id
      item.title = item.name
    })
    setState({
      orgTreeData,
    })
  }, [orgTree])

  useEffect(() => {
    if (record?.id && open) {
      let data = cloneDeep(record)
      console.log(data, state)

      form.setFieldsValue({
        ...data,
        startDate: dayjs(data?.startDate),
        type: data?.type == 0 ? '10507' : data?.type == 1 ? '10508' : '',
        idType: isNil(data?.idType) ? 'identification' : data?.idType,
      })
      setState({
        positionList: [],
        primaryDeptPosId: data?.primaryDeptPosId || '',
        seletedPosition: data?.serviceInfos || [],
      })
      // console.log(data, idcardOptions);
      if (data?.serviceInfos) {
        data.serviceInfos = data?.serviceInfos.map((d: any) => {
          d.positionCode = d?.departPosition?.positionCode
          d.positionName = d?.departPosition?.positionName
          d.code = d?.departPosition?.code
          d.name = d?.departPosition?.name
          return d
        })
        tableRef.current && tableRef.current.updateDataSource(data?.serviceInfos)
      }

      // console.log('data:', data, path, state.resourceOptions);
    }

    if (!record?.id && open) {
      setState({
        positionList: [],
        seletedPosition: [],
        primaryDeptPosId: '',
      })
      tableRef.current && tableRef.current.reset()
    }
    return () => {}
  }, [record])

  const idNumberValidate = async () => {
    const data = form.getFieldsValue(['idNumber', 'id'])
    let res = await employeeCheck(data)
    if (res && !res?.status) {
      form.setFields([
        {
          name: 'idNumber',
          value: data?.idNumber,
          errors: ['该证件号已存在'],
        },
      ])
    }
  }

  const phoneValidate = async () => {
    const data = form.getFieldsValue(['phone', 'id'])
    let res = await employeeCheck(data)
    if (res && !res?.status) {
      form.setFields([
        {
          name: 'phone',
          value: data.phone,
          errors: ['该手机号已存在'],
        },
      ])
    }
  }

  const workNumberValidate = async () => {
    const data = form.getFieldsValue(['workerNumber', 'id'])
    let res = await employeeCheck(data)
    console.log(res)
    if (res && !res?.status) {
      form.setFields([
        {
          name: 'workerNumber',
          value: data.workerNumber,
          errors: ['该工号已存在'],
        },
      ])
    }
  }

  const setMainPosition = (record: any, status: boolean) => {
    console.log(record, status)
    let primaryDeptPosId = record?.departPosition?.id ? record?.departPosition?.id : record.id
    if (state?.seletedPosition.length > 1) {
      setState({ primaryDeptPosId })
    }
    if (state?.seletedPosition.length == 1) {
      setState({ primaryDeptPosId: !status ? primaryDeptPosId : 0 })
    }
  }

  const setSuperior = (record: any, superiorItem: any) => {
    const nextSelected = state.seletedPosition.map((d: any) => {
      if (d.id === record.id) {
        if (superiorItem) {
          d.superiorName = superiorItem.name
          d.superiorWorkNumber = superiorItem.workerNumber
          d.superiorId = superiorItem?.id
        } else {
          d.superiorName = ''
          d.superiorWorkNumber = ''
          d.superiorId = ''
        }
      }
      return d
    })
    console.log(nextSelected)

    setState({
      seletedPosition: nextSelected,
    })
  }

  const deleteDeptPosition = (record: any) => {
    let { seletedPosition } = state
    seletedPosition = seletedPosition.filter((d: any) => d.id !== record?.id)
    if (state.primaryDeptPosId === record?.id) {
      setState({ primaryDeptPosId: '' })
    }
    setState({
      seletedPosition,
    })
    tableRef.current && tableRef.current.updateDataSource(seletedPosition)
  }

  const onOrgTreeSelect = (selectedKeys: any[]) => {
    const id = selectedKeys[0]
    if (!isNil(id)) {
      fetchDept(id)
    } else {
      setState({ positionList: [] })
    }
  }

  const addPosition = (record: any) => {
    const { seletedPosition } = state
    seletedPosition.push(record)
    setState({
      seletedPosition,
    })
    tableRef.current && tableRef.current.updateDataSource(seletedPosition)
  }

  const fetchDept = (departmentId: any) => {
    setState({ positionLoading: true })
    getPositionList({ departmentId }).then((res: any) => {
      setState({ positionList: res, positionLoading: false })
    })
  }

  // 提交
  const onFinish = () => {
    form.validateFields().then((values: any) => {
      const { seletedPosition } = state
      if (!seletedPosition || !seletedPosition.length) {
        return message.error('请选择职位')
      }

      values.serviceInfos = []
      console.log(seletedPosition, state)

      for (const item of seletedPosition) {
        let primaryDeptPosId = item?.departPosition?.id ? item?.departPosition?.id : item.id

        values.serviceInfos.push({
          // departmentPositionId:item?.id,
          // empAdminId: item.superiorId,
          departmentPositionId: primaryDeptPosId,
          // personInChargeWorkNumber: item.superiorWorkNumber,
          empAdminId: item?.superiorId ? item?.superiorId : item?.amdinEmployee?.id,
          serviceType: state.primaryDeptPosId == primaryDeptPosId ? 0 : 1,
        })
      }
      // values.id = values.id ? values.id : 0;
      values.type = values.type == '10508' ? 1 : values.type == '10507' ? 0 : ''
      values.status = values.status == true ? 1 : 0

      values.startDate = dayjs(values.startDate).format('YYYY-MM-DD')
      if (values.resignedDate) {
        values.resignedDate = dayjs(values.resignedDate).format('YYYY-MM-DD HH:mm:ss')
      } else {
        values.resignedDate = ''
      }

      values.primaryDeptPosId = state.primaryDeptPosId
      console.log(values)
      // return;
      setSubmitLoading(true) //values.id != 0 ? 'employee/employee/updateById' : 'employee/employee/save'
      employeeSaveOrEdit('employee/employee/save', values)
        .then((res: any) => {
          const msg = get(res, 'data.message') || ''
          message.success(msg)
          onClose?.()
          reload?.()
          form.resetFields()
        })
        .finally(() => setSubmitLoading(false))
    })
  }

  const closeModal = () => {
    form.resetFields()
    onClose?.()
  }

  const extension = {
    request: {},
    events: {},
    customRender: {
      actionTool(text: any, record: any): any {
        if (record.code === 'SDLC' || record.code === 'RootOrg') {
          return null
        }
        return (
          <STableActions>
            <SActionBtn
              confirm
              title="确定要删除吗"
              onClick={() => deleteDeptPosition(record)}
              danger
            >
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      mainPositionRender(text: any, record: any) {
        let bool = false
        let primaryDeptPosId = record?.departPosition?.id ? record?.departPosition?.id : record.id
        if (primaryDeptPosId == state.primaryDeptPosId) {
          //主职位是唯一的，checked选中就表示该条数据id为主职位id
          bool = true
        }
        return (
          <Switch
            checked={bool}
            onChange={() => setMainPosition(record, bool)}
            checkedChildren="是"
            unCheckedChildren="否"
          />
        )
      },
      superiorNameRender(text: any, record: any) {
        return (
          <SelectSuperior
            data={record}
            onChange={(superiorItem: any) => setSuperior(record, superiorItem)}
          />
        )
      },
    },
  }

  return (
    <SDrawer
      title={record?.id ? `${title}` : `${title}`}
      open={open}
      // cancelText='返回'
      // okText='提交'
      // onSubmit={onFinish}
      onClose={closeModal}
      // isHideResetBtn={true}
      loading={submitLoading}
      width={'80vw'}
      footer={[
        <Button onClick={closeModal}>返回</Button>,
        <Button
          loading={submitLoading}
          style={{ marginLeft: '10px' }}
          type="primary"
          onClick={onFinish}
        >
          提交
        </Button>,
      ]}
      destroyOnClose
      // extra={<ResetPassword {...props} />}
    >
      <div style={{ paddingLeft: '70px', paddingRight: '50px' }}>
        <div>
          <ResetPassword {...props} />
          <Form
            form={form}
            {...formItemLayout}
            autoComplete="off"
            labelAlign={'right'}
            layout="vertical"
          >
            <Form.Item label="#" name="id" hidden>
              <Input disabled />
            </Form.Item>

            <Row>
              <Col span={formSpan}>
                <Form.Item
                  label="工号"
                  name="workerNumber"
                  rules={[
                    { required: true, message: '请输入工号' },
                    () => ({
                      validator: (_, value) => {
                        if (/[0-9]+/gi.test(value)) {
                          return Promise.resolve()
                        }
                        return Promise.reject(new Error('工号为纯数字'))
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="请输入工号"
                    disabled={!isNil(record?.id)}
                    onBlur={workNumberValidate}
                  />
                </Form.Item>
              </Col>
              <Col span={formSpan}>
                <Form.Item
                  label="姓名"
                  name="name"
                  rules={[{ required: true, message: '请输入姓名' }]}
                >
                  <Input placeholder="请输入姓名" />
                </Form.Item>
              </Col>
              <Col span={formSpan}>
                <Form.Item
                  label="手机号"
                  name="phone"
                  rules={[
                    { required: true, message: '请输入手机号' },
                    {
                      required: true,
                      message: '请输入正确格式的手机号',
                      pattern: /^1[0-9]\d{9}$/g,
                    },
                  ]}
                >
                  <Input placeholder="请输入手机号" maxLength={11} onBlur={phoneValidate} />
                </Form.Item>
              </Col>
              <Col span={formSpan}>
                <Form.Item
                  label="花名"
                  name="alias"
                  rules={[{ required: true, message: '请输入花名' }]}
                >
                  <Input placeholder="请输入花名" />
                </Form.Item>
              </Col>
              <Col span={formSpan}>
                <Form.Item
                  label="证件类型"
                  name="idType"
                  rules={[{ required: true, message: '请选择证件类型' }]}
                >
                  <Select placeholder="请选择证件类型">
                    {idcardOptions.map((d: any) => (
                      <Select.Option key={d?.key}>{d?.name}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={formSpan}>
                <Form.Item
                  label="证件号"
                  name="idNumber"
                  rules={[{ required: true, message: '请输入证件号' }]}
                >
                  <Input placeholder="请输入证件号" onBlur={idNumberValidate} />
                </Form.Item>
              </Col>

              <Col span={formSpan}>
                <Form.Item
                  label="邮箱"
                  name="email"
                  rules={[{ required: true, message: '请输入正确的邮箱地址', type: 'email' }]}
                >
                  <Input placeholder="请输入正确的邮箱地址" />
                </Form.Item>
              </Col>

              <Col span={formSpan}>
                <Form.Item
                  label="员工类型"
                  name="type"
                  rules={[{ required: true, message: '请选择员工类型' }]}
                >
                  <Select placeholder="请选择员工类型">
                    {positionTypeOptions.map((d: any) => (
                      <Select.Option key={d.id}>{d.name}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={formSpan}>
                <Form.Item
                  label="入职时间"
                  name="startDate"
                  rules={[{ required: true, message: '请选择入职时间' }]}
                >
                  <DatePicker style={{ width: '100%' }} disabled={!!record?.id} />
                </Form.Item>
              </Col>

              <Form.Item name="resignedDate" hidden>
                <Input />
              </Form.Item>

              <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  return record?.id && getFieldValue('resignedDate') ? (
                    <Col span={formSpan}>
                      <Form.Item
                        label="离职时间"
                        name="resignedDate"
                        rules={[{ required: true, message: '请选择入职时间' }]}
                      >
                        <Input style={{ width: '100%' }} disabled />
                      </Form.Item>
                    </Col>
                  ) : null
                }}
              </Form.Item>

              <Col span={formSpan}>
                <Form.Item
                  label="状态"
                  name="status"
                  valuePropName="checked"
                  rules={[{ required: true, message: '请选择状态' }]}
                  initialValue={true}
                >
                  <Switch checkedChildren="在职" unCheckedChildren="离职" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div>
          <SLowcodeList
            rowKey={'id'}
            ref={tableRef}
            {...extension}
            config={config}
            pagination={false}
            scroll={{ y: 300 }}
          />
        </div>
        <Collapse>
          <Collapse.Panel header="职位列表" key="1">
            <Row gutter={10}>
              <Col span={6}>
                <div style={{ border: '1px solid #d9d9d9', height: 302 }}>
                  <Tree
                    showLine
                    treeData={state.orgTreeData}
                    height={300}
                    onSelect={onOrgTreeSelect}
                  />
                </div>
              </Col>
              <Col span={18}>
                <Table
                  rowKey="id"
                  bordered
                  pagination={false}
                  loading={state.positionLoading}
                  scroll={{ y: 262 }}
                  size="small"
                  columns={[
                    { title: '职位编码', dataIndex: 'code', width: 150 },
                    { title: '职位名称', dataIndex: 'name', width: 200 },
                    {
                      title: '添加职位',
                      key: 'action',
                      width: 100,
                      className: 'columnCenter',
                      render: (text, record) => {
                        return (
                          <Button
                            type="primary"
                            size="small"
                            icon={<PlusOutlined />}
                            disabled={!!state.seletedPosition.find((d: any) => d.id === record.id)}
                            onClick={() => addPosition(record)}
                          >
                            添加
                          </Button>
                        )
                      },
                    },
                  ]}
                  dataSource={state.positionList}
                />
              </Col>
            </Row>
          </Collapse.Panel>
        </Collapse>
      </div>
    </SDrawer>
  )
}

const SelectSuperior = (props: any) => {
  const { onChange, data, open } = props

  const [state, setState] = useSetState<any>({
    list: [],
    value: undefined,
  })

  useEffect(() => {
    console.log(data)
    if (!isNil(data?.amdinEmployee)) {
      let newData = data?.amdinEmployee
      setState({
        value: newData?.id,
        list: [{ id: newData?.id, name: newData?.name, workerNumber: newData?.workerNumber }],
      })
    }
  }, [data])

  const onSearch = (val: any) => {
    getEmployeeList(
      { nameWorkerPhoneLike: val },
      {
        pageId: 1,
        pageSize: 100,
      }
    ).then(res => {
      setState({ list: res })
    })
  }

  const _onChange = (value: any) => {
    setState({ value })
    const item = state.list.find((d: any) => d?.id == value)
    onChange && onChange(item)
  }

  return (
    <>
      <Select
        placeholder="姓名/工号搜索"
        allowClear
        showSearch
        onSearch={onSearch}
        onChange={_onChange}
        style={{ width: '100%' }}
        filterOption={false}
        value={state?.value}
      >
        {state?.list.map((d: any, i: number) => (
          <Select.Option key={d?.id || i} value={d?.id} label={`${d?.name}(${d?.workerNumber})`}>
            {d?.name}({d?.workerNumber})
          </Select.Option>
        ))}
      </Select>
    </>
  )
}

const ResetPassword = (props: any) => {
  const { record } = props
  const [loading, setLoading] = useState(false)

  const onRestPwd = () => {
    // console.log('record', record);
    setLoading(true)
    resetPassword({ login: record.workerNumber }).then(res => {
      message.success(res || 'ok')
      setLoading(false)
    })
  }
  return record?.id ? (
    <STableActions>
      <SActionBtn type="primary" onClick={onRestPwd} loading={loading}>
        重置密码
      </SActionBtn>
    </STableActions>
  ) : null
}

export default EditDrawer
